import store from '../store'

const dataLayerService = {
  push: (data) => {
    const user = store?.state?.auth?.user

    const plan_name = data.plan_name || getCurrentPlanName(user)
    if (plan_name) {
      data.plan_name = capitalizeFirstLetter(plan_name)
    }

    const user_id = data.user_id || user?.id
    const email = data.email || user?.email
    const admin_id = +window?.config?.logged_in_admin_id > 0 ? +window.config.logged_in_admin_id : null

    if (admin_id) {
      data.admin_id = admin_id
    }
    if (user_id) {
      data.user_id = user_id
    }
    if (email) {
      data.email = email
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  },
}

function getCurrentPlanName(user) {
  if (!user) return null

  const hasUbb = !!user.has_usage_based_billing
  const hasActiveStore = user.active_stores?.length > 0

  if (hasUbb && hasActiveStore && user.usage_based_billing?.current_tier?.name) {
    return user.usage_based_billing.current_tier.name
  }

  const isDisconnectedUbb = hasUbb && !hasActiveStore
  if (user.is_free_user || isDisconnectedUbb) return 'Free'
  if (user.is_pro_user) return 'Pro'
  if (user.is_plus_user) return 'Plus'
  if (user.is_select_user) return 'Private Agent'

  return null
}

function capitalizeFirstLetter(string) {
  if (typeof string !== 'string' || string?.trim() === '') {
    return ''
  }
  string = string?.trim()
  return string?.charAt(0)?.toUpperCase() + string?.slice(1)
}

export { dataLayerService }
